import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4c571003")

_pushScopeId("data-v-4c571003")
const _hoisted_1 = {
  class: "p-hd",
  ref: "pageHead"
}
const _hoisted_2 = {
  key: 0,
  class: "hd"
}
const _hoisted_3 = { class: "op-l" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查看题目")
const _hoisted_5 = { class: "hd-c-wrap" }
const _hoisted_6 = { class: "hd-c" }
const _hoisted_7 = {
  key: 0,
  class: "time"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 总剩余时间：")
const _hoisted_9 = {
  key: 1,
  class: "tit"
}
const _hoisted_10 = { class: "op-r" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_13 = { class: "side-sheet" }
const _hoisted_14 = {
  key: 1,
  class: "ana-box"
}
const _hoisted_15 = { class: "his-box" }
const _hoisted_16 = { class: "edit-area" }
const _hoisted_17 = { style: {"margin":"0 10px"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_question_detail_head = _resolveComponent("question-detail-head")
  const _component_answer_analysis = _resolveComponent("answer-analysis")
  const _component_commit_history = _resolveComponent("commit-history")
  const _component_answer_page_foot = _resolveComponent("answer-page-foot")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", {
    class: 'page' + (!_ctx.isSingQuesMod ? ' fixed' : '')
  }, [
    _createVNode("div", _hoisted_1, [
      (!_ctx.isSingQuesMod)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                plain: "",
                class: 'btn' + (_ctx.showQuestionContent ? ' on' : ''),
                onClick: _ctx.handleViewQuestion
              }, {
                default: _withId(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["class", "onClick"])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                (_ctx.isExam && _ctx.time)
                  ? (_openBlock(), _createBlock("p", _hoisted_7, [
                      _hoisted_8,
                      _createVNode("span", null, _toDisplayString(_ctx.time), 1)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isSingQuesMod && !_ctx.isExam)
                  ? (_openBlock(), _createBlock("p", _hoisted_9, _toDisplayString(_ctx.title), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_el_button, {
                type: "primary",
                plain: "",
                class: "btn",
                onClick: _ctx.handleClose
              }, {
                default: _withId(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "primary",
                class: "btn",
                onClick: _ctx.handleSave
              }, {
                default: _withId(() => [
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isSingQuesMod)
        ? (_openBlock(), _createBlock(_component_question_detail_head, {
            key: 1,
            title: _ctx.title,
            onSave: _ctx.handleSave,
            questionTypeName: _ctx.questionTypeName
          }, null, 8, ["title", "onSave", "questionTypeName"]))
        : _createCommentVNode("", true)
    ], 512),
    _withDirectives(_createVNode("div", {
      class: 'p-main clearfix' + (_ctx.showQuestionContent || _ctx.showAnalysis || _ctx.showHistory ? ' side-on' : ''),
      style: { height: _ctx.pageBodyHeight + 'px', margin: '0 10px' }
    }, [
      _createVNode("div", _hoisted_13, [
        (_ctx.showQuestionContent)
          ? (_openBlock(), _createBlock("p", {
              key: 0,
              class: `q-cont ${_ctx.canNotSelectQuestion ? 'limited' : ''}`
            }, [
              _createVNode("span", {
                innerHTML: _ctx.quesData.questionContent
              }, null, 8, ["innerHTML"]),
              _createTextVNode(" " + _toDisplayString(_ctx.quesData.score ? '（' + _ctx.quesData.score + '分）' : ''), 1)
            ], 2))
          : _createCommentVNode("", true),
        (!_ctx.isExam && _ctx.showAnalysis)
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              _createVNode(_component_answer_analysis, {
                analysisData: _ctx.analysisData,
                questionType: 5,
                lang: _ctx.quesData.lang
              }, null, 8, ["analysisData", "lang"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_15, [
          (!_ctx.isExam && _ctx.showHistory)
            ? (_openBlock(), _createBlock(_component_commit_history, {
                key: 0,
                type: 5,
                historyData: _ctx.historyData,
                onDelete: _ctx.onDeleteCommitHistory,
                lang: _ctx.quesData.lang
              }, null, 8, ["historyData", "onDelete", "lang"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode("iframe", {
          src: `${_ctx.PROGRAMURL}${_ctx.langName}/?token=${_ctx.token}${_ctx.quesData.answer ? `&codeUrl=${_ctx.quesData.answer}` : ''}`,
          ref: "iframe",
          style: {"min-height":"680px"}
        }, null, 8, ["src"])
      ])
    ], 6), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode("div", _hoisted_17, [
      (_ctx.isSingQuesMod)
        ? (_openBlock(), _createBlock(_component_answer_page_foot, {
            key: 0,
            ref: "pageFoot",
            type: 2,
            showAnalysis: _ctx.showAnalysis,
            showHistory: _ctx.showHistory,
            showQuestion: _ctx.showQuestionContent,
            onViewQuestion: _ctx.handleViewQuestion,
            onViewAnalysis: _ctx.onViewAnalysis,
            onViewHistory: _ctx.onViewHistory,
            onRandom: _ctx.handleRandomQuestion,
            onPrev: _ctx.handlePrevQuestion,
            onNext: _ctx.handleNextQuestion,
            analysisData: _ctx.analysisData,
            historyData: _ctx.historyData
          }, null, 8, ["showAnalysis", "showHistory", "showQuestion", "onViewQuestion", "onViewAnalysis", "onViewHistory", "onRandom", "onPrev", "onNext", "analysisData", "historyData"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
})